import React from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import Typography from '@mui/material/Typography';
import { TELEFONIA_MODALS } from 'src/utils/constants';

const HabilitarDeshabilitar = (props) => {
  const { open, close, flag, afterConfirm } = props;
  const { fetch } = useFetch();
  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);
  const confirmHandler = async () => {
    const nuevo_estado =
      flag === TELEFONIA_MODALS.HABILITAR_NUM_BLOQUEADOS ? 1 : 0;
    await fetch(`/telefonia/numeros-bloqueados/${props.data.id}`, {
      method: 'PATCH',
      data: { estado: nuevo_estado },
    });
    afterConfirm();
    close();
  };
  return (
    <Modal
      title={
        flag === TELEFONIA_MODALS.HABILITAR_NUM_BLOQUEADOS
          ? `Habilitar Bloqueo`
          : 'Deshabilitar Bloqueo'
      }
      content={
        <>
          <Typography>¿Estás seguro de efectuar este cambio? </Typography>
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={true}
      onConfirm={confirmHandler}
    />
  );
};

export default HabilitarDeshabilitar;
